import React from 'react'
import { useSelector } from 'react-redux'

import { Routes, Route } from 'react-router-dom'

// Pages
import RestaurantAllergens from './Pages/RestaurantAllergens/RestaurantAllergens'
import ShopInfo from './Pages/ShopInfo/ShopInfo'
import SellConditions from './Pages/SellConditions/SellConditions'
import Payments from './Pages/Payments/Payments'
import Delivery from './Pages/Delivery/Delivery'
import Returns from './Pages/Returns/Returns'
import Privacy from './Pages/Privacy/Privacy'

import Home from './Home/Home'
import Shop from './Shop/Shop'
import Reservations from './Reservations/Reservations'
import ReservationDate from './Reservations/ReservationDate'

import { OffersList, ProductsListFlat, ProductsListGroupped } from './Shop/ProductsList'
import { ProductDetails } from './Shop/ProductDetails'
import { ProductsSearch } from './Shop/ProductsSearch'
import Order from './Order/Order'
import OrderConfirm from './Order/OrderConfirm'
import OrderPayment from './Order/OrderPayment'
import { CategoryDetails } from './Shop/CategoryDetails'

function Routing({ toggleCategoriesOpen }) {
	const shop = useSelector(state => state.shop)
	const catDisplayMode = shop.profiles.ueby_categories_display_mode

	return (<Routes>
		<Route path="/" exact element={<Home
			toggleCategoriesOpen={toggleCategoriesOpen}
		/>} />
		<Route path="/shop" exact element={<Shop
			toggleCategoriesOpen={toggleCategoriesOpen}
		/>} />
		<Route path="/reservations" exact element={<Reservations
			toggleCategoriesOpen={toggleCategoriesOpen}
		/>} />
		<Route path="/reservations/*" element={<ReservationDate />} />
		<Route path="/allergeniRistorante" exact element={<RestaurantAllergens />} />
		<Route path="/negozio" exact element={<ShopInfo />} />
		<Route path="/condizioniDiVendita" exact element={<SellConditions />} />
		<Route path="/metodiPagamento" exact element={<Payments />} />
		<Route path="/metodiConsegna" exact element={<Delivery />} />
		<Route path="/resiRimborsi" exact element={<Returns />} />
		<Route path="/informativaPrivacy" exact element={<Privacy />} />
		<Route path="/order/confirm" exact element={<OrderConfirm />} />
		<Route path="/order/payment" exact element={<OrderPayment />} />
		<Route path="/order/create" exact element={<Order />} />
		<Route path="/offers" exact element={<OffersList />} />
		<Route path="/shop/search" exact element={<ProductsSearch />} />
		<Route path="/shop/prod/:productParam" element={<ProductDetails />} />
		{catDisplayMode == '1' && <Route path="/shop/*" element={<CategoryDetails />} /> }
		{catDisplayMode == '2' && <Route path="/shop" exact element={<ProductsListFlat />} /> }
		{catDisplayMode == '3' && <Route path="/shop" exact element={<ProductsListGroupped />} /> }
	</Routes>)
}

export default Routing
